import React, { useLayoutEffect, useState } from "react";
import DataGrid, { Column, Paging, Pager, SearchPanel } from "devextreme-react/data-grid";
import * as XLSX from "xlsx";
import { Item } from "devextreme-react/radio-group";
import { Button, LoadIndicator, Template, Toolbar } from "devextreme-react";
import { useNavigate, useParams } from "react-router-dom";
import { QuoteService } from "../../apis/apiServices";
import Swal from "sweetalert2";
import { LoadingIndicator } from "devextreme-react/bar-gauge";
import TabStorage from "../../helper/TabStorage";
export default function UploadExAComponentQuote() {
  const history = useNavigate();
  const { id } = useParams()
  const [uploadedData, setUploadedData] = useState([]);
  const [quoteId, setQuoteId] = useState(id)
  const [quoteData, setQuoteData] = useState(null)
  const [consumptionHeaderId, setConsumptionHeaderId] = useState(0)
  const [loading, setLoading] = useState(false)

  const sampleData = [
    {
      "EntityLegalName": "530 RIVERDALE OWNERS",
      "AccountNumber": 87097350000,
      // "UtilityAccountNo": 87097350000,
      "ServiceAddress1": "530 RIVERDALE AVE",
      // "ServiceAddress2": "530 RIVERDALE AVENUE",
      "City": "YONKERS",
      "State": "NEW YORK",
      "ZipCode": 10705,
      "commodityType": "Gas",
      "rateClass": "A",
      "poolPoint": "B",
      "taxType": "Residential",
      "January-25": 100,
      "February-25": 110,
      "March-25": 120,
      "April-25": 210,
      "May-25": 300,
      "June-25": 180,
      "July-25": 200,
      "August-25": 280,
      "September-25": 160,
      "October-25": 250,
      "November-25": 240,
      "December-25": 300,
      "AnnualTotal": 2450
    },
    {
      "EntityLegalName": "82-90 CARYL AVE OWNERS",
      "AccountNumber": 10197300006,
      // "UtilityAccountNo": 10197300006,
      "ServiceAddress1": "82 CARYL AVE",
      // "ServiceAddress2": "530 RIVERDALE AVENUE",
      "City": "YONKERS",
      "State": "NEW YORK",
      "ZipCode": 10705,
      "commodityType": "Gas",
      "rateClass": "A",
      "poolPoint": "B",
      "taxType": "Residential",
      "January-25": 100,
      "February-25": 110,
      "March-25": 120,
      "April-25": 210,
      "May-25": 300,
      "June-25": 180,
      "July-25": 200,
      "August-25": 280,
      "September-25": 160,
      "October-25": 250,
      "November-25": 240,
      "December-25": 300,
      "AnnualTotal": 2450
    }
  ];

  useLayoutEffect(() => {
    // document.querySelector("#pageTitle").innerHTML = "Quote - 1203 	(4/8/2024)"; addQuoteEntityBulkUpload
    fetchQuoteDetails();
    fetchComsumtion();
    document.querySelector("#pageTitle").innerHTML = `Upload Bulk Entity`;
  }, []);
  const fetchComsumtion = async () => {
    try {
      const response = await QuoteService.getEntityConsumptionHeaderByQuoteId(id);
      if (!response?.data?.isSuccess) {
        return;
      }
      console.log("consumptionId===>", response?.data?.payload[0]?.id);
      if (response?.data?.payload[0]?.id > 0) {
        setConsumptionHeaderId(response?.data?.payload[0]?.id)
      } else {
        setConsumptionHeaderId(0)
      }
    } catch (error) {
      console.error("Error fetching consumption data:", error);
    }
  };

  const fetchQuoteDetails = async () => {
    debugger
    const user = await TabStorage.getItem("user");
    try {
      let body = {
        customerId: user?.customerId,
        branchId: user?.branchId,
        id: quoteId,
        statusId: 0,
        startDate: "",
        endDate: "",
        userId: user?.userId,
        quoteOwnerId: 0,
        quoteTypes: 0,
        overDue: false,
      };
      const response = await QuoteService.getQuoteById(body);
      if (!response?.data?.isSuccess) {
        return;
      }
      let quote = response?.data?.payload[0];
      setQuoteData(quote);
    } catch (error) { }
  };
  const sumMonthlyValues = (rows) => {
    console.log("rows==>", rows);
    debugger;

    // Standard month mappings (short to full name)
    const monthMapping = {
      jan: "January", feb: "February", mar: "March", apr: "April",
      may: "May", jun: "June", jul: "July", aug: "August",
      sep: "September", oct: "October", nov: "November", dec: "December"
    };

    // **Step 1: Filter out invalid rows**
    const validRows = rows.filter((row) => {
      // Key mapping to ensure correct key names
      const accountNumber = row["Account No"] || row["AccountNumber"];
      // const utilityAccountNo = row["Utility Account No"] || row["UtilityAccountNo"];
      console.log("accountNumber==>", accountNumber);
      // console.log("utilityAccountNo==>", utilityAccountNo);
      return (
        accountNumber &&
        // utilityAccountNo &&
        Object.keys(row).some((key) =>
          key.match(/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i) && row[key]
        )
      );
    });

    return validRows.map((row) => {
      let annualTotal = 0;
      let formattedRow = { ...row };

      // Regex to match month names in various formats (keeps the full key with year)
      const monthRegex = /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*([-/\s]?\d{0,4})?$/i;

      Object.keys(row).forEach((key) => {
        const match = key.match(monthRegex);
        if (match) {
          let monthShort = match[1].toLowerCase(); // Extract short month (e.g., "jan")
          let yearPart = match[2] || ""; // Capture the year part (if present)
          let fullMonth = monthMapping[monthShort]; // Convert to full month name

          annualTotal += Number(row[key]) || 0; // Add only numeric values

          // Preserve original key with year while ensuring readability
          let formattedKey = `${fullMonth}${yearPart}`;
          formattedRow[formattedKey] = row[key]; // Keep original key
        }
      });

      return { ...formattedRow, AnnualTotal: annualTotal };
    });
  };


  const handleFileUpload = async (event) => {
    debugger
    setLoading(true)
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      if (jsonData.length > 1) {
        const headers = jsonData[0];
        const rows = jsonData.slice(1).map((row) =>
          headers.reduce((acc, key, index) => {
            acc[key] = row[index] || "";
            return acc;
          }, {})
        );
        setLoading(false)
        const updatedData = sumMonthlyValues(rows);
        setUploadedData(updatedData);
      }
    };
    reader.readAsArrayBuffer(file);
  };
  const saveAs = (blob, fileName) => {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const ExcelJS = require("exceljs");

  const submitXsls = async (consumptionHeaderIdProps) => {
    debugger;
    console.log("uploadedData===>", uploadedData);
    const user = TabStorage.getItem("user");
    const keywordMapping = {
      "Entity Name": "entityLegalName",
      "EntityName": "entityLegalName",
      "Account No": "accountNumber",
      "AccountNo": "accountNumber",
      // "Utility Account No": "utilityAccountNo",
      "Service Address": "serviceAddress1",
      "ServiceAddress": "serviceAddress1",
      // "Service Address 2": "serviceAddress2",
      "City": "city",
      "State": "state",
      "Zip Code": "zipCode",
      "ZipCode": "zipCode",
      // "Service Location Id": "serviceLocationId",
      // "ServiceLocationId": "serviceLocationId",
      "Tax Type": "taxType",
      "TaxType": "taxType",
      "Rate Class": "rateClass",
      "RateClass": "rateClass",
      "Pool Point": "poolPoint",
      "PoolPoint": "poolPoint",
      "Commodity Type": "commodityType",
      "CommodityType": "commodityType",
      "Annual Total": "annualTotal",
      "AnnualTotal": "annualTotal"
    };

    let body = uploadedData.map((data, index) => {
      let mappedData = {
        id: 0,
        quoteId: Number(id) || 0,
        utilityCompanyId: 0,
        utilityCompany: "",
        commodityType: "",
        serviceAddress2: "",
        companyId: user?.companyId || 0,
        branchId: user?.branchId || 0,
        consumptionHeaderId: consumptionHeaderIdProps || 0,
        isAnnualEntityConsumption: false,
        commodityUnits: "",
        commodityUnitsId: 0
      };

      // Dynamically map properties based on the keywordMapping
      Object.keys(keywordMapping).forEach((key) => {
        const mappedKey = keywordMapping[key];
        if (data.hasOwnProperty(key)) {
          mappedData[mappedKey] = data[key];
        }
      });

      return mappedData;
    });

    // **Step 2: Identify and map months**
    const monthMapping = {
      "jan": 1, "feb": 2, "mar": 3, "apr": 4,
      "may": 5, "jun": 6, "jul": 7, "aug": 8,
      "sep": 9, "oct": 10, "nov": 11, "dec": 12
    };

    const monthRegex = /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*([-/\s]?\d{0,4})?$/i;

    uploadedData.forEach((data, dataIndex) => {
      let sortedMonths = [];

      Object.keys(data).forEach((key) => {
        const match = key.toLowerCase().match(monthRegex);
        if (match) {
          const monthShort = match[1].toLowerCase();
          const monthIndex = monthMapping[monthShort];

          sortedMonths.push({ key, value: data[key] || 0, monthIndex });
        }
      });

      // **Step 3: Sort and assign month values**
      sortedMonths.sort((a, b) => a.monthIndex - b.monthIndex);

      sortedMonths.forEach((month, index) => {
        body[dataIndex][`month${index + 1}`] = month.value; // Assigning month values
        // body[dataIndex][`month${index + 1}Name`] = month.key; // Keeping original month names
      });
    });

    // **API Call**
    console.log("body==>", body);
    debugger;

    QuoteService.addQuoteEntityBulkUpload(user?.userId, user?.companyId, id, body)
      .then((response) => {
        debugger
        if (response?.data?.isSuccess) {
          Swal.fire("Added!", "Bulk upload has been successfully.", "success");
          setUploadedData([])
          setTimeout(() => {
            history(-1)
          }, 3000);
        }
      })
      .catch((error) => {
        debugger
        console.log("API Error:", error);
      });
    setLoading(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    debugger;
    console.log("uploadedData===>", uploadedData);

    try {
      if (consumptionHeaderId == 0) {
        const user = TabStorage.getItem("user");
        // Default body structure
        let body = {
          id: 0,
          quoteId: Number(id) || 0,
          month1Name: "",
          month2Name: "",
          month3Name: "",
          month4Name: "",
          month5Name: "",
          month6Name: "",
          month7Name: "",
          month8Name: "",
          month9Name: "",
          month10Name: "",
          month11Name: "",
          month12Name: "",
          isAnnualEntityConsumption: false
        }

        // **Step 1: Identify months from uploadedData**
        const monthMapping = {
          "january": 1, "february": 2, "march": 3, "april": 4,
          "may": 5, "june": 6, "july": 7, "august": 8,
          "september": 9, "october": 10, "november": 11, "december": 12
        };

        const monthRegex = /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)[a-z]*([-/\s]?\d{0,4})?$/i

        let sortedMonths = [];

        Object.keys(uploadedData[0]).forEach((key) => {
          const match = key.toLowerCase().match(monthRegex);
          if (match) {
            const monthName = match[1].toLowerCase();
            const monthIndex = monthMapping[monthName];
            sortedMonths.push({ key, value: uploadedData[0][key], monthIndex });
          }
        });

        // **Step 2: Sort months in order**
        sortedMonths.sort((a, b) => a.monthIndex - b.monthIndex);

        // **Step 3: Assign month values in body**
        sortedMonths.forEach((month, index) => {
          // body.quoteEntityConsumption[`month${index + 1}`] = month.value || 0;
          body[`month${index + 1}Name`] = month.key;
        });

        // API Call
        QuoteService.addQuoteEntityConsumptionHeadersByQuoteId(id, user?.userId, user?.companyId, body)
          .then((response) => {
            debugger
            if (response?.data?.isSuccess) {
              let consumptionHeaderIdd = response?.data?.payload;
              submitXsls(consumptionHeaderIdd);
            }
          })
          .catch((error) => {
            console.log("API Error:", error);
          });
      }
      else {
        debugger
        submitXsls(consumptionHeaderId);
      }
    } catch (error) {
      console.log("error===>", error);
    }
  };

  console.log("uploadedData===>", uploadedData);

  return (
    <div className="container-fluid pt-2">
      <div className="card">
        <div className="card-body">
          <input
            type="file"
            id="fileUpload"
            accept=".xlsx, .csv"
            style={{ display: "none" }}
            onChange={handleFileUpload}
          />
          <Toolbar className="btngrouptheme1 p-1">
            <Item
              location="before"
              widget="dxButton"
              options={{
                elementAttr: {
                  class: "btn btn-sm btn-secondary text-white",
                },
                icon: "download",
                text: "Download Sample File",
                onClick: () => {
                  const workbook = new ExcelJS.Workbook();
                  const worksheet = workbook.addWorksheet("SampleDataQuoteEntities");

                  // Define columns with headers
                  worksheet.columns = [
                    { header: "Entity Name", key: "EntityLegalName", width: 30 },
                    { header: "Account No", key: "AccountNumber", width: 20 },
                    // { header: "Utility Account No", key: "UtilityAccountNo", width: 20 },
                    { header: "Service Address", key: "ServiceAddress1", width: 30 },
                    // { header: "Service Address 2", key: "ServiceAddress2", width: 30 },
                    { header: "Service Location Id", key: "serviceLocationId", width: 30 },
                    { header: "City", key: "City", width: 15 },
                    { header: "State", key: "State", width: 15 },
                    { header: "Zip Code", key: "ZipCode", width: 10 },
                    { header: "Commodity Type", key: "commodityType", width: 15 },
                    { header: "Rate Class", key: "rateClass", width: 15 },
                    { header: "Pool Point", key: "poolPoint", width: 15 },
                    { header: "Tax Type", key: "taxType", width: 15 },
                    { header: "January-25", key: "January-25", width: 12 },
                    { header: "February-25", key: "February-25", width: 12 },
                    { header: "March-25", key: "March-25", width: 12 },
                    { header: "April-25", key: "April-25", width: 12 },
                    { header: "May-25", key: "May-25", width: 12 },
                    { header: "June-25", key: "June-25", width: 12 },
                    { header: "July-25", key: "July-25", width: 12 },
                    { header: "August-25", key: "August-25", width: 12 },
                    { header: "September-25", key: "September-25", width: 12 },
                    { header: "October-25", key: "October-25", width: 12 },
                    { header: "November-25", key: "November-25", width: 12 },
                    { header: "December-25", key: "December-25", width: 12 },
                    { header: "Annual Total", key: "AnnualTotal", width: 15 },
                  ];


                  // Add rows (automatically maps keys)
                  worksheet.addRows(sampleData);

                  // Apply styling (bold headers)
                  worksheet.getRow(1).eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.alignment = { horizontal: "center" };
                  });

                  // Generate and download file
                  workbook.xlsx.writeBuffer().then((data) => {
                    const blob = new Blob([data], {
                      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    saveAs(blob, "SampleDataQuoteEntities.xlsx");
                  });
                },
              }}
            />
            {/* <Item
              location="before"
              widget="dxButton"
              options={{
                elementAttr: {
                  class: "btn btn-sm btn-secondary text-white",
                },
                icon: "upload",
                text: loading ? "Uploading..." : "Upload File",
             
                disabled: loading,
              }}
            /> */}
            { }
            <Item
              location="before"
              widget="dxButton"
              options={{
                elementAttr: {
                  class: "btn btn-sm btn-secondary text-white",
                },
                icon: loading ? "refresh" : "upload", // Hide default icon when loading
                text: loading ? "Uploading..." : (
                  "Upload File"
                ),
                onClick: () => document.getElementById("fileUpload").click(),
                disabled: loading, // Disable button during upload
              }}
            >
              {/* <Template name="content">
                {() =>
                  loading ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <LoadIndicator width={20} height={20} visible={true} style={{ marginRight: "8px" }} />
                      Uploading...
                    </div>
                  ) : (
                    "Upload File"
                  )
                }
              </Template> */}
            </Item>

          </Toolbar>
          <DataGrid
            dataSource={uploadedData}
            showBorders={true}
            columnAutoWidth={true}
          >
            {uploadedData.length > 0 &&
              Object.keys(uploadedData[0]).map((key) => (
                <Column key={key} dataField={key} caption={key} />
              ))}
            <Paging defaultPageSize={15} />
            <Pager
              displayMode="compact"
              showNavigationButtons={true}
              showInfo={true}
              visible={true}
            />
            <SearchPanel
              visible={true}
              highlightCaseSensitive={true}
              width={240}
              placeholder="Search..."
            />

          </DataGrid>
          <div className="d-flex justify-content-end">
            <Button
              type="default"
              text="Go Back"
              onClick={() => history(-1)}
              elementAttr={{ class: "btn btn-sm btn-secondary text-white mt-3 mr-2" }}
            />
            <Button
              type="default"
              text={"Upload"}
              onClick={() => {
                handleSubmit()
              }}
              disabled={loading}
              elementAttr={{ class: "btn btn-sm btn-primary text-white mt-3" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
